import React from 'react';

import {Col, Row, Image, Container} from "react-bootstrap";
import DownloadButton from '../../common/DownloadButton';
import EmailForm from "../../common/EmailForm";

function Hero() {
    return (
        <Container style={{marginBottom: 160, padding: 20}}>
            <Row className={'justify-content-center'}>
                <Col sm={12} md={12} lg={5} style={{display: 'flex', flexDirection: 'column', justifyContent: 'center', marginBottom: 40}}>
                    <h1>Legal Draft AI</h1>
                    <p style={{marginTop: 20, marginBottom: 40}}>
                    Introducing our revolutionary app that uses AI to create draft legal contracts instantly! Say goodbye to the lengthy and complex process of drafting contracts from scratch. With our app, you can now generate legally binding agreements in just a few clicks. Our AI technology ensures that your contracts are accurate, comprehensive and tailored to your specific needs. Save time and money with our user-friendly platform that simplifies the entire contract drafting process. Try it out today and experience the ease and convenience of our AI-powered contract creation.
                    </p>

                    <DownloadButton/>
                </Col>

                <Col sm={12} md={6} lg={5} style={{display: 'flex', justifyContent: 'center'}}>
                    <img style={{width: '100%', height: 'auto'}} src={"/images/mocks/1.png"}/>
                </Col>
            </Row>
        </Container>
    );
}

export default Hero;
